// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3UQTw","header":"MergedInvoice_header__1irqw"};